import {MainService} from "./service/mainService";
import {MainServiceModule} from "./MainServiceModuleConfiguration";


MainServiceModule
    .createNewModule()
    .service('MainService', ['$http', MainService]);

